import request from '@/utils/request2';
export function delTemplate(data) {
  return request.post('admin/insurance-template/delete', data);
}

//上传工种视频 列表
export function getUploadDataList(data) {
  return request.post('admin/work-scene/list', data);
}

//工种视频审核接口
export function auditVedio(data) {
  return request.post('admin/work-scene/audit', data);
}
export function getVedioDetail(data) {
  return request.post('admin/work-scene/detail', data);
}